import { createSlice, createAsyncThunk } from '@reduxjs/toolkit'
import { getApiData } from 'services/RateCardService'

export const getData = createAsyncThunk(
    'claculator/data/getData',
    async (datas) => {
        const response = await getApiData(datas)
        const data = {
            from: response.data?.map((item) => item.from_location) || [],
            to: response.data?.map((item) => item.to_location) || [],
        }
        return data
    },
)

const recordData = {
    company: '',
    transport_provider: '',
    service_name: [],
    product_type: [],
    quantity: '',
    weight: '',
    from_zone: '',
    to_zone: '',
    date: '',
    service_type: [],
    work_code: '',
    hours: '',
    country: '',
    state: '',
    client_name: '',
}

const dataSlice = createSlice({
    name: 'claculator/data',
    initialState: {
        loading: false,
        view: recordData,
        data: [],
    },
    reducers: {
        setData: (state, { payload }) => {
            state.data = payload
        },
    },
    extraReducers: (builder) => {
        builder
            .addCase(getData.pending, (state) => {
                state.loading = true
            })
            .addCase(getData.fulfilled, (state, { payload }) => {
                state.loading = false
                state.data = payload
            })
            .addCase(getData.rejected, (state) => {
                state.loading = false
                state.data = []
            })
    },
})

export const { setData } = dataSlice.actions

export default dataSlice.reducer
